document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const panel = document.querySelector('[data-mobile-nav-panel]');

  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const nextState = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nextState ? 'true' : 'false');
    });
  }
});
